export default __webpack_public_path__ + "8f32fd6b4bdbde7bc2454ea67bc13332.svg";